import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const addEditServiceModalSchema = yupResolver(
  yup.object({
    grouping: yup.string().required('Grupo é obrigatório'),
    descriptionId: yup.string().required('Descrição é obrigatória'),
    grossUnitValue: yup.string().notRequired(),
    tax: yup.string().notRequired(),
    totalQuantity: yup
      .string()
      .required('Qtd total é obrigatório')
      .test('totalQuantity-not-zero', 'A quantidade total deve ser maior que zero', (value) => {
        if (!value) return false
        const numValue = Number(value)
        return !isNaN(numValue) && numValue > 0
      }),
    grossTotal: yup.string().required('Total bruto é obrigatório'),
    netTotal: yup.string().required('Total líquido é obrigatório'),
    day1: yup.string().test('day1', 'Campo obrigatório', (value) => {
      if (value === undefined) return true
      return !!value
    }).test('day1-not-negative', 'O valor não pode ser negativo', (value) => {
      if (!value || value === undefined) return true
      const numValue = Number(value)
      return !isNaN(numValue) && numValue >= 0
    }),
    day2: yup.string().test('day2', 'Campo obrigatório', (value) => {
      if (value === undefined) return true
      return !!value
    }).test('day2-not-negative', 'O valor não pode ser negativo', (value) => {
      if (!value || value === undefined) return true
      const numValue = Number(value)
      return !isNaN(numValue) && numValue >= 0
    }),
    day3: yup.string().test('day3', 'Campo obrigatório', (value) => {
      if (value === undefined) return true
      return !!value
    }).test('day3-not-negative', 'O valor não pode ser negativo', (value) => {
      if (!value || value === undefined) return true
      const numValue = Number(value)
      return !isNaN(numValue) && numValue >= 0
    }),
    day4: yup.string().test('day4', 'Campo obrigatório', (value) => {
      if (value === undefined) return true
      return !!value
    }).test('day4-not-negative', 'O valor não pode ser negativo', (value) => {
      if (!value || value === undefined) return true
      const numValue = Number(value)
      return !isNaN(numValue) && numValue >= 0
    }),
    day5: yup.string().test('day5', 'Campo obrigatório', (value) => {
      if (value === undefined) return true
      return !!value
    }).test('day5-not-negative', 'O valor não pode ser negativo', (value) => {
      if (!value || value === undefined) return true
      const numValue = Number(value)
      return !isNaN(numValue) && numValue >= 0
    }),
    day6: yup.string().test('day6', 'Campo obrigatório', (value) => {
      if (value === undefined) return true
      return !!value
    }).test('day6-not-negative', 'O valor não pode ser negativo', (value) => {
      if (!value || value === undefined) return true
      const numValue = Number(value)
      return !isNaN(numValue) && numValue >= 0
    }),
    day7: yup.string().test('day7', 'Campo obrigatório', (value) => {
      if (value === undefined) return true
      return !!value
    }).test('day7-not-negative', 'O valor não pode ser negativo', (value) => {
      if (!value || value === undefined) return true
      const numValue = Number(value)
      return !isNaN(numValue) && numValue >= 0
    })
  })
)
